export default {
      id: "sli-logout-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.43681d49.svg#sli-logout",
      toString: function () {
        return this.url;
      }
    }